// extracted by mini-css-extract-plugin
export default {"login":"Login_login__a9BU2","form":"Login_form__Tby5q","row":"Login_row__1YGqR","ctaLink":"Login_ctaLink__FShA1"};